/**
 * @file 接口名称
 */
export const API_LOGIN = '/api/User/login';
export const API_AOTULOGIN = '/api/User/aotulogin';
export const API_COURSE_CATEGORY = '/api/Course/category';
export const API_COURSE_LATEST = '/api/Course/latest';
export const API_COURSE_INDEX = '/api/Course/index';
export const API_COURSE_DETAIL = '/api/Course/detail';
export const API_ORDER_CREATE = '/api/Order/create';
export const API_ORDER_MY = '/api/Order/my';
export const API_GOODS_DETAIL = '/api/Goods/detail';
export const API_TEACHER_DETAIL = '/api/Teacher/detail/';
export const API_SETTINGS_BANNER= '/api/Settings/banner';
export const API_USER_AUTOLOGIN = '/api/User/autologin';
export const API_USER_LOGIN = '/api/User/login';
export const API_USER_DETAIL = '/api/User/detail';
export const API_USER_SMS = '/api/User/sms';





// WEBPACK FOOTER //
// ./src/constant/api.js